export const RELATED_NEWS_LIGHTNING_VIEWBOX = '0 0 20 24';

/** Referans mockup ile uyumlu dolu şimşek */
export const RELATED_NEWS_LIGHTNING_PATH =
  'M11.5 0 1 13.5h6.5L5.5 24 19 10.5H12.5L11.5 0z';

export function buildRelatedNewsLightningSvgHtml(): string {
  return `<svg class="content-card-category-icon" xmlns="http://www.w3.org/2000/svg" viewBox="${RELATED_NEWS_LIGHTNING_VIEWBOX}" fill="currentColor" aria-hidden="true" focusable="false"><path d="${RELATED_NEWS_LIGHTNING_PATH}"/></svg>`;
}
